/**
 * Módulo de Formulários
 * Responsável por funcionalidades de formulários e máscaras de input
 */

import { formataValorMonetario } from "../../utils/common.js";
import { getMasksValidator } from "../shared/masks-validator.js";

// Instância do validador de máscaras
let masksValidator = null;

/**
 * Inicializa o módulo de formulários
 */
export function initFormsModule() {
    // Inicializar MasksValidator primeiro
    const masksValidator = getMasksValidator();

    initInputMasks();
    initFormValidation();
    initCNPJLookup();
    initVehicleData();
    initFormEvents();
}

/**
 * Inicializa máscaras de input usando jQuery Mask Plugin diretamente
 */
function initInputMasks() {
    // Aguardar jQuery Mask Plugin estar disponível
    if (typeof $.fn.mask !== "undefined") {
        // Aplicar máscaras diretamente
        $(".phone-mask").mask("(00) 00000-0000");
        $(".cpf-mask").mask("000.000.000-00");
        $(".cnpj-mask").mask("00.000.000/0000-00");
        $(".cep-mask").mask("00000-000");
        $(".plate-mask").mask("AAA-0000");
        $(".year-mask").mask("0000");
        $(".km-mask").mask("#.##0", { reverse: true });

        // Máscara de dinheiro
        $(".money-mask").mask("#.##0,00", { reverse: true });

        // Máscara de porcentagem
        $(".percent-mask").mask("##0,00%", { reverse: true });
    }
}

/**
 * Inicializa validação de formulários
 */
function initFormValidation() {
    // Validação de CPF
    $(".cpf-mask").on("blur", function () {
        const cpf = $(this).val().replace(/\D/g, "");
        if (cpf.length === 11 && !isValidCPF(cpf)) {
            $(this).addClass("is-invalid");
            showFieldError($(this), "CPF inválido");
        } else {
            $(this).removeClass("is-invalid");
            hideFieldError($(this));
        }
    });

    // Validação de CNPJ
    $(".cnpj-mask").on("blur", function () {
        const cnpj = $(this).val().replace(/\D/g, "");
        if (cnpj.length === 14 && !isValidCNPJ(cnpj)) {
            $(this).addClass("is-invalid");
            showFieldError($(this), "CNPJ inválido");
        } else {
            $(this).removeClass("is-invalid");
            hideFieldError($(this));
        }
    });

    // Validação de email
    $('input[type="email"]').on("blur", function () {
        const email = $(this).val();
        if (email && !isValidEmail(email)) {
            $(this).addClass("is-invalid");
            showFieldError($(this), "Email inválido");
        } else {
            $(this).removeClass("is-invalid");
            hideFieldError($(this));
        }
    });

    // Validação de campos obrigatórios
    $("input[required], select[required], textarea[required]").on(
        "blur",
        function () {
            if (!$(this).val()) {
                $(this).addClass("is-invalid");
                showFieldError($(this), "Este campo é obrigatório");
            } else {
                $(this).removeClass("is-invalid");
                hideFieldError($(this));
            }
        }
    );
}

/**
 * Inicializa busca por CNPJ
 */
function initCNPJLookup() {
    $(".cnpj-lookup").on("blur", function () {
        const cnpj = $(this).val().replace(/\D/g, "");

        if (cnpj.length === 14) {
            lookupCNPJ(cnpj);
        }
    });
}

/**
 * Busca dados da empresa por CNPJ
 * @param {string} cnpj - CNPJ para busca
 */
function lookupCNPJ(cnpj) {
    const loadingElement = $(".cnpj-loading");

    loadingElement.show();

    $.ajax({
        url: `https://www.receitaws.com.br/v1/cnpj/${cnpj}`,
        method: "GET",
        dataType: "jsonp",
        success: function (data) {
            if (data.status === "OK") {
                fillCompanyData(data);
            } else {
                showErrorMessage("CNPJ não encontrado ou inválido");
            }
        },
        error: function () {
            showErrorMessage("Erro ao buscar dados do CNPJ");
        },
        complete: function () {
            loadingElement.hide();
        },
    });
}

/**
 * Preenche dados da empresa no formulário
 * @param {Object} data - Dados da empresa
 */
function fillCompanyData(data) {
    $('input[name="company_name"]').val(data.nome || "");
    $('input[name="fantasy_name"]').val(data.fantasia || "");
    $('input[name="email"]').val(data.email || "");
    $('input[name="phone"]').val(data.telefone || "");

    // Endereço
    $('input[name="address"]').val(data.logradouro || "");
    $('input[name="number"]').val(data.numero || "");
    $('input[name="complement"]').val(data.complemento || "");
    $('input[name="neighborhood"]').val(data.bairro || "");
    $('input[name="city"]').val(data.municipio || "");
    $('select[name="state"]')
        .val(data.uf || "")
        .trigger("change");
    $('input[name="zipcode"]').val(data.cep || "");

    showSuccessMessage("Dados preenchidos automaticamente");
}

/**
 * Inicializa dados de veículos
 */
function initVehicleData() {
    // Carrega marcas ao inicializar
    loadVehicleBrands();

    // Carrega modelos quando marca é selecionada
    $('select[name="brand_id"]').on("change", function () {
        const brandId = $(this).val();
        if (brandId) {
            loadVehicleModels(brandId);
        } else {
            $('select[name="model_id"]')
                .empty()
                .append(
                    '<option value="">Selecione uma marca primeiro</option>'
                );
        }
    });
}

/**
 * Carrega marcas de veículos
 */
function loadVehicleBrands() {
    const brandSelect = $('select[name="brand_id"]');

    if (brandSelect.length === 0) return;

    $.ajax({
        url: "/api/vehicle-brands",
        method: "GET",
        success: function (response) {
            brandSelect
                .empty()
                .append('<option value="">Selecione uma marca</option>');

            response.forEach(function (brand) {
                brandSelect.append(
                    `<option value="${brand.id}">${brand.name}</option>`
                );
            });
        },
        error: function () {},
    });
}

/**
 * Carrega modelos de veículos por marca
 * @param {number} brandId - ID da marca
 */
function loadVehicleModels(brandId) {
    const modelSelect = $('select[name="model_id"]');

    modelSelect.empty().append('<option value="">Carregando...</option>');

    $.ajax({
        url: `/api/vehicle-models/${brandId}`,
        method: "GET",
        success: function (response) {
            modelSelect
                .empty()
                .append('<option value="">Selecione um modelo</option>');

            response.forEach(function (model) {
                modelSelect.append(
                    `<option value="${model.id}">${model.name}</option>`
                );
            });
        },
        error: function () {
            modelSelect
                .empty()
                .append('<option value="">Erro ao carregar modelos</option>');
        },
    });
}

/**
 * Inicializa eventos de formulário
 */
function initFormEvents() {
    // Previne envio duplo de formulário
    $("form").on("submit", function () {
        const submitBtn = $(this).find('button[type="submit"]');
        submitBtn.prop("disabled", true);

        setTimeout(function () {
            submitBtn.prop("disabled", false);
        }, 3000);
    });

    // Auto-save em formulários longos
    $(
        ".auto-save-form input, .auto-save-form select, .auto-save-form textarea"
    ).on("change", function () {
        const form = $(this).closest("form");
        autoSaveForm(form);
    });

    // DESABILITADO: Confirmação antes de sair de formulários não salvos
    // Esta funcionalidade foi substituída pelo Form Guard (utils/form-guard.js)
    // O Form Guard gerencia a proteção de formulários de forma mais inteligente
    // Form protection: Desabilitado - usando Form Guard
}

/**
 * Auto-salva formulário
 * @param {jQuery} form - Formulário para salvar
 */
function autoSaveForm(form) {
    const formData = form.serialize();
    const autoSaveUrl = form.data("auto-save-url");

    if (!autoSaveUrl) return;

    $.ajax({
        url: autoSaveUrl,
        method: "POST",
        data: formData,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success: function () {
            showAutoSaveIndicator();
        },
        error: function () {},
    });
}

/**
 * Mostra indicador de auto-save
 */
function showAutoSaveIndicator() {
    const indicator = $(".auto-save-indicator");
    indicator.text("Salvo automaticamente").fadeIn();

    setTimeout(function () {
        indicator.fadeOut();
    }, 2000);
}

/**
 * Valida CPF
 * @param {string} cpf - CPF para validar
 * @returns {boolean} - True se válido
 */
function isValidCPF(cpf) {
    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 9; i++) {
        sum += parseInt(cpf.charAt(i)) * (10 - i);
    }

    let remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.charAt(9))) return false;

    sum = 0;
    for (let i = 0; i < 10; i++) {
        sum += parseInt(cpf.charAt(i)) * (11 - i);
    }

    remainder = (sum * 10) % 11;
    if (remainder === 10 || remainder === 11) remainder = 0;

    return remainder === parseInt(cpf.charAt(10));
}

/**
 * Valida CNPJ
 * @param {string} cnpj - CNPJ para validar
 * @returns {boolean} - True se válido
 */
function isValidCNPJ(cnpj) {
    if (cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(\d)\1{13}$/.test(cnpj)) return false;

    // Valida DVs
    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    let digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0))) return false;

    length = length + 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;

    for (let i = length; i >= 1; i--) {
        sum += numbers.charAt(length - i) * pos--;
        if (pos < 2) pos = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

    return result === parseInt(digits.charAt(1));
}

/**
 * Valida email
 * @param {string} email - Email para validar
 * @returns {boolean} - True se válido
 */
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Mostra erro em campo
 * @param {jQuery} field - Campo com erro
 * @param {string} message - Mensagem de erro
 */
function showFieldError(field, message) {
    let errorElement = field.siblings(".invalid-feedback");

    if (errorElement.length === 0) {
        errorElement = $('<div class="invalid-feedback"></div>');
        field.after(errorElement);
    }

    errorElement.text(message);
}

/**
 * Esconde erro em campo
 * @param {jQuery} field - Campo para esconder erro
 */
function hideFieldError(field) {
    field.siblings(".invalid-feedback").remove();
}

/**
 * Mostra mensagem de sucesso
 * @param {string} message - Mensagem de sucesso
 */
function showSuccessMessage(message) {
    // Implementar toast ou alert de sucesso
}

/**
 * Mostra mensagem de erro
 * @param {string} message - Mensagem de erro
 */
function showErrorMessage(message) {
    // Implementar toast ou alert de erro
}
